import React from "react";
import { LANGS, getLang, setLang } from "../i18n";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

export default function LanguageSwitcher({ value, onChange, small }) {
  const current = value ?? getLang();
  const handle = (v) => {
    if (onChange) onChange(v);
    else setLang(v);
  };
  return (
    <Select value={current} onValueChange={handle}>
      <SelectTrigger
        data-testid="language-switcher"
        className={`border-zinc-200 bg-white font-mono text-xs uppercase tracking-wider rounded-md ${small ? "h-8 w-[110px]" : "h-10 w-[140px]"}`}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="rounded-md">
        {LANGS.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>
            <span className="mr-2">{l.flag}</span>
            {l.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
